var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":_vm.pushView}},[_vm._v(" View ")])}
var staticRenderFns = []

export { render, staticRenderFns }